// Shared product identity for the widget and standalone recipe PDF.
export const brandWordmarkHtml = '<span style="font-family:Manrope,Arial,sans-serif;font-weight:700;white-space:nowrap"><span style="color:#C8202F">Red</span><span style="color:#000000">Concierge</span></span>';
